// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Target the specific section */
.Campaign_custom-scrollbar__MsNvG::-webkit-scrollbar {
  width: 2px; /* Adjust scrollbar width */
}

.Campaign_custom-scrollbar__MsNvG::-webkit-scrollbar-track {
  background: var(--disabled-color); /* Track background color */
}

.Campaign_custom-scrollbar__MsNvG::-webkit-scrollbar-thumb {
  background-color: var(--para-color); /* Thumb color */
  border-radius: 5px; /* Optional: Rounded corners */
}

.Campaign_custom-scrollbar__MsNvG::-webkit-scrollbar-thumb:hover {
  background: var(--para-color); /* Thumb hover effect */
}

.Campaign_boxStyling__b1g\\+x {
  background-color: white;
  border: 1px solid gray;
  padding: 30px;
  border-radius: 8px;
  /* box-shadow: 0 0 6px 2px rgba(0, 0, 0, 0.18) */
}

.Campaign_boxStylingFabAndPrint__-vjKQ {
  margin-top: 16px;
  background-color: white;
  border: 1px solid gray;
  padding: 30px;
  border-radius: 8px;
  overflow: auto;
  /* box-shadow: 0 0 6px 2px rgba(0, 0, 0, 0.18) */
}


`, "",{"version":3,"sources":["webpack://./src/components/AdminportalFolder/Campaign/Campaign.module.css"],"names":[],"mappings":"AAAA,gCAAgC;AAChC;EACE,UAAU,EAAE,2BAA2B;AACzC;;AAEA;EACE,iCAAiC,EAAE,2BAA2B;AAChE;;AAEA;EACE,mCAAmC,EAAE,gBAAgB;EACrD,kBAAkB,EAAE,8BAA8B;AACpD;;AAEA;EACE,6BAA6B,EAAE,uBAAuB;AACxD;;AAEA;EACE,uBAAuB;EACvB,sBAAsB;EACtB,aAAa;EACb,kBAAkB;EAClB,gDAAgD;AAClD;;AAEA;EACE,gBAAgB;EAChB,uBAAuB;EACvB,sBAAsB;EACtB,aAAa;EACb,kBAAkB;EAClB,cAAc;EACd,gDAAgD;AAClD","sourcesContent":["/* Target the specific section */\n.custom-scrollbar::-webkit-scrollbar {\n  width: 2px; /* Adjust scrollbar width */\n}\n\n.custom-scrollbar::-webkit-scrollbar-track {\n  background: var(--disabled-color); /* Track background color */\n}\n\n.custom-scrollbar::-webkit-scrollbar-thumb {\n  background-color: var(--para-color); /* Thumb color */\n  border-radius: 5px; /* Optional: Rounded corners */\n}\n\n.custom-scrollbar::-webkit-scrollbar-thumb:hover {\n  background: var(--para-color); /* Thumb hover effect */\n}\n\n.boxStyling {\n  background-color: white;\n  border: 1px solid gray;\n  padding: 30px;\n  border-radius: 8px;\n  /* box-shadow: 0 0 6px 2px rgba(0, 0, 0, 0.18) */\n}\n\n.boxStylingFabAndPrint {\n  margin-top: 16px;\n  background-color: white;\n  border: 1px solid gray;\n  padding: 30px;\n  border-radius: 8px;\n  overflow: auto;\n  /* box-shadow: 0 0 6px 2px rgba(0, 0, 0, 0.18) */\n}\n\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"custom-scrollbar": `Campaign_custom-scrollbar__MsNvG`,
	"boxStyling": `Campaign_boxStyling__b1g+x`,
	"boxStylingFabAndPrint": `Campaign_boxStylingFabAndPrint__-vjKQ`
};
export default ___CSS_LOADER_EXPORT___;
